export default __webpack_public_path__ + "cf6e656f8830c1024fe285ab813c10c4.svg";